// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"z--z"};